import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { API_SERVER, API_SERVER_VERSION } from '../../app.constants';

@Injectable()
export class PasswordResetService {

  constructor(private http: Http) {}

  save(mail: string): Observable<any> {
    return this.http.post(API_SERVER + 'api/' + API_SERVER_VERSION + '/account/reset_password/init', mail);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/login/password-reset.service.ts